<template>
  <div class="form-group">
    <input
      :type="type"
      :name="name"
      :placeholder="label"
      class="input-text"
      v-bind="$attrs"
      :class="{ error: appendErrorClass(name) }"
      @input="$emit('update', $event.target.value)"
      v-on="$listeners"
    />

    <BaseInputTextareaErrors :name="lowDash(name)" :v="v" />
  </div>
</template>

<script>
import BaseInputTextareaErrors from '@/components/BaseInputTextareaErrors'
import baseInputTextareaMixin from '@/mixins/baseInputTextareaMixin'
import lowDash from '@/utils/convert-to-low-dash'

export default {
  components: { BaseInputTextareaErrors },
  mixins: [baseInputTextareaMixin],

  props: {
    type: {
      type: String,
      default: 'text',
      validator(value) {
        return [
          'email',
          'number',
          'password',
          'search',
          'tel',
          'text',
          'url',
        ].includes(value)
      },
    },
  },

  methods: {
    lowDash(str) {
      return lowDash(str)
    },
  },
}
</script>

<style scoped>
.input-text {
  @apply appearance-none border border-main-500 px-4 py-2 w-full rounded;
  box-sizing: border-box;
}

.input-text:focus {
  @apply outline-none shadow-outline;
}

.error {
  @apply border border-2 border-red-500;
}
</style>
